import { Landmark, ShieldCheck } from "lucide-react";

export default function BankDetails({ state, setState, errors }) {
  const set = (field, value) =>
    setState((s) => ({ ...s, bank: { ...s.bank, [field]: value } }));

  return (
    <div data-testid="wizard-step-bank">
      <h2 className="text-3xl sm:text-4xl font-medium tracking-tight mb-2">
        Bank details
      </h2>
      <p className="text-secondary-brand mb-8 leading-relaxed">
        Required for premium debits, refunds, and claim payouts to your account.
      </p>

      <div className="bg-surface border border-subtle rounded-2xl p-6">
        <div className="flex items-center gap-3 mb-5">
          <span className="w-10 h-10 rounded-full accent-soft-bg flex items-center justify-center">
            <Landmark size={20} className="accent-text" />
          </span>
          <div>
            <h3 className="text-lg font-medium">Primary account</h3>
            <p className="text-sm text-secondary-brand">
              This account will be used for all policy transactions.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          <div className="sm:col-span-2">
            <label className="form-label" htmlFor="accountNumber">
              Account Number
            </label>
            <input
              id="accountNumber"
              type="text"
              inputMode="numeric"
              maxLength={18}
              value={state.bank.accountNumber}
              onChange={(e) =>
                set(
                  "accountNumber",
                  e.target.value.replace(/\D/g, "").slice(0, 18)
                )
              }
              className={`form-input ${errors.accountNumber ? "error" : ""}`}
              placeholder="9 – 18 digits"
              data-testid="input-account-number"
              autoComplete="off"
            />
            {errors.accountNumber && (
              <p className="error-text" data-testid="error-account-number">
                {errors.accountNumber}
              </p>
            )}
          </div>

          <div className="sm:col-span-2">
            <label className="form-label" htmlFor="ifscCode">
              IFSC Code
            </label>
            <input
              id="ifscCode"
              type="text"
              maxLength={11}
              value={state.bank.ifscCode}
              onChange={(e) =>
                set(
                  "ifscCode",
                  e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 11)
                )
              }
              className={`form-input ${errors.ifscCode ? "error" : ""}`}
              placeholder="e.g. HDFC0001234"
              data-testid="input-ifsc-code"
              autoComplete="off"
            />
            {errors.ifscCode && (
              <p className="error-text" data-testid="error-ifsc-code">
                {errors.ifscCode}
              </p>
            )}
          </div>
        </div>

        <div className="mt-6 flex items-start gap-2 text-xs text-muted-brand">
          <ShieldCheck size={14} className="mt-0.5 flex-shrink-0" />
          <span>
            Your bank details are encrypted in transit and used solely for
            policy-related transactions.
          </span>
        </div>
      </div>
    </div>
  );
}
